'use client';

import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '../../../utils/cn/cn';

const ColorButtonTooltipProvider = TooltipPrimitive.Provider;

const ColorButtonTooltip = TooltipPrimitive.Root;

const ColorButtonTooltipTrigger = TooltipPrimitive.Trigger;

const ColorButtonTooltipArrow = TooltipPrimitive.Arrow;

const ColorButtonTooltipPortal = TooltipPrimitive.Portal;

const ColorButtonTooltipContent = React.forwardRef<
  React.ComponentRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      'bg-color-background-base text-color-text-dark text-size-body-xs animate-slide-up-and-fade z-50 rounded-[8px] p-1 shadow-md will-change-[opacity,transfom]',
      className,
    )}
    {...props}
  />
));
ColorButtonTooltipContent.displayName = 'ColorButtonTooltipContent';

export {
  ColorButtonTooltip,
  ColorButtonTooltipTrigger,
  ColorButtonTooltipContent,
  ColorButtonTooltipProvider,
  ColorButtonTooltipArrow,
  ColorButtonTooltipPortal,
};
